module.exports = __webpack_public_path__ + "img/method-women-right.6e40f071.png";